import axios from "axios";
import { urlBase } from "../../../Constante/Url";
import { UserTockem } from "../../../Utils/autenticacao";

function getConfig(params) {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
}

async function getAtualizacao(page, pageSize, params) {
  let skip = (page - 1) * pageSize;
  const url = urlBase + "atualizacao/?limit=" + pageSize + "&offset=" + skip;

  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
  const response = await axios.get(url, config);
  return response;
}

async function getAtualizacaoId(id) {
  const url = urlBase + `atualizacao/${id}/`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
}

async function getAtualizacaoCartorio(page, pageSize, params) {
  let skip = (page - 1) * pageSize;
  const url = `${urlBase}atualizacao-cartorio/?limit=${pageSize}&offset=${skip}`;
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };

  const response = await axios.get(url, config);
  return response;
}
async function getAtualizacaoCartId(id) {
  const url = `${urlBase}atualizacao-cartorio/${id}/`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
}
async function getAtualizacaoErro(page, pageSize, id, tipoErro) {
  let skip = (page - 1) * pageSize;
  const url = `${urlBase}atualizacao-cartorio-log-erro/?atualizacaocartorio_id=${id}&limit=${pageSize}&offset=${skip}&tipo_erro=${tipoErro}`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
}
const getBuscarErro = async (id) => {
  const url = `${urlBase}atualizacao-cartorio/${id}/buscar-tipo-atualizacao-erro/`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

const getListarUsuarios = async () => {
  const url = `${urlBase}usuario/registro/`;
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

async function deleteAtualizacaoCartorio(id) {
  const url = urlBase + `atualizacao-cartorio/${id}/`;
  const config = getConfig();
  const response = await axios.delete(url, config);
  return response;
}

async function deleteAtualizacao(id) {
  const url = urlBase + `atualizacao/${id}/`;
  const config = getConfig();
  const response = await axios.delete(url, config);
  return response;
}

async function postAtualizacao(data) {
  const url = urlBase + `atualizacao/`;
  const config = getConfig();
  const response = await axios.post(url, data, config);
  return response;
}

async function postAtualizacaoCartorio(data) {
  const url = urlBase + "atualizacao-cartorio/";
  const config = getConfig();
  const response = await axios.post(url, data, config);
  return response;
}

async function postExecutarAtualizacao(id) {
  const url = urlBase + `atualizacao/${id}/executar-atualizacao/`;
  const config = getConfig();
  const response = await axios.post(url, id, config);
  return response;
}

const getGerarPlanilha = async (atualizacao_id) => {
  const response = await axios.get(
    `${urlBase}atualizacao-cartorio/gerar-planilha/${atualizacao_id}/`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
      responseType: "blob",
    }
  );
  return response;
};

const getEmTeste = (usuario_id_param, ticket = "") => {
  const params_req = { usuario_id_param: usuario_id_param };
  if (ticket.trim()) {
    params_req.ticket = ticket.trim();
  }

  const config = getConfig(params_req);

  const response = axios.get(`${urlBase}usuario/em_teste/`, config);

  return response;
};

const rotasEmTeste = {
  dominio_em_teste: "dominio",
  tabela_em_teste: "tabela",
  campo_em_teste: "campo",
  foreignKey_em_teste: "ForeignKey",
  primaryKey_em_teste: "PrimaryKey",
  index_em_teste: "Index",
  trigger_em_teste: "Trigger",
  procedure_em_teste: "Procedure",
  view_em_teste: "View",
  sequences_em_teste: "Sequence",
  comando_em_teste: "Comando",
  parametro_em_teste: "config",
  permissao_em_teste: "menu-item",
};

const desmarcarEmTeste = (tipo, id) => {
  const rota = rotasEmTeste[tipo];
  if (!rota || id == null) {
    throw new Error("Registro invalido para desmarcar em teste.");
  }
  return axios.patch(`${urlBase}${rota}/${id}/`, { em_teste: false }, getConfig());
};

const AtualizacaoRequest = {
  desmarcarEmTeste,
  getEmTeste,
  getBuscarErro,
  getAtualizacao,
  postAtualizacao,
  getGerarPlanilha,
  getAtualizacaoId,
  getListarUsuarios,
  deleteAtualizacao,
  getAtualizacaoErro,
  getAtualizacaoCartId,
  getAtualizacaoCartorio,
  postAtualizacaoCartorio,
  postExecutarAtualizacao,
  deleteAtualizacaoCartorio,
};

export default AtualizacaoRequest;
